import type { Rotina } from '@/types/pagesMenu';


const nomesRotinasExpedicao = {
	AVERIGUACAO_VOLUMES: 'Averiguação de volumes na expedição',
	AUDITORIA_VOLUMES_SEPARADOS_CARGA: 'Auditoria dos volumes separados por carga de volumes',
	SEPARACAO_PICKING_UNIDADE: 'Separação Coletor',
	AVERIGUACAO_SEPARACAO_CONSOLIDADA: 'Averiguação da separação consolidada',
	/*
	 * A 362 (antes rotulada aqui como B332) saiu do menu do COLETOR em
	 * 28/09/2026: a tela dela é de desktop — `definePageMeta({ layout:
	 * "default" })` — e passou para o `menuStation`, no grupo Expedição.
	 *
	 * O nome fica declarado porque o tipo `RotinasExpedicao` é usado em outros
	 * pontos do menu.
	 */
	LIBERACAO_DIVERGENCIAS_SEPARACAO: 'Liberação de divergências da separação consolidada',
} as const;

export type RotinasExpedicao = typeof nomesRotinasExpedicao[keyof typeof nomesRotinasExpedicao];

// Aqui são definidas as rotinas de expedição para usar no comoposable
const rotinasExpedicao: Rotina[] = [
	{
		categoria: 'Expedição',
		label: nomesRotinasExpedicao.AVERIGUACAO_VOLUMES,
		nome: 'mni_ColetorDadosAveriguacaoVolumes',
		rotina: "PROC_AVERIGUACAO_PICKING_CX_COLETOR",
		tela: 'PROC_AVERIGUACAO_PICKING_CX_COLETOR',
		disponivel: true
	},
	{
		categoria: 'Expedição',
		label: nomesRotinasExpedicao.AUDITORIA_VOLUMES_SEPARADOS_CARGA,
		nome: 'mni_AuditoriaVolumesSeparadosCarga',
		rotina: "PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR",
		tela: 'PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR',
		disponivel: true
	},
	{
		/*
		 * ATENÇÃO ao campo `nome`: é comparado contra `ACEUSU_ID_MENU_PF` da
		 * `CORE_ACESSO_USUARIO`, e o item some do menu em silêncio quando não
		 * casa.
		 *
		 * Estava `mni_ConvocacaoSeparacaoPicking`, escolhido quando o menu do
		 * Delphi ainda não estava disponível para conferência. Aquele id é de
		 * OUTRA rotina: pelo catálogo de captions do Delphi ele é a
		 * "A333 - Convocações da Separação do Picking". Corrigido em 28/09/2026
		 * para o id que o próprio catálogo dá a esta tela:
		 * `mni_Separacao_picking_unidade_guia_separacao`, caption
		 * "B326 - Separação de Mercadorias no Picking".
		 *
		 * Ninguém perde o item com a troca: na base da dev, os 4 usuários do id
		 * antigo estão entre os 9 do id certo.
		 */
		categoria: 'Expedição',
		label: nomesRotinasExpedicao.SEPARACAO_PICKING_UNIDADE,
		nome: 'mni_Separacao_picking_unidade_guia_separacao',
		rotina: "separacao/coletor",
		tela: 'PROC_SEPARACAO_PICKING_UNIDADE_COLETOR',
		disponivel: true
	},
	{
		/*
		 * `mni_AveriguacaoSeparacaoConsolidada` foi conferido nas fontes:
		 * `SIST_MAINFORM.dfm:3346` tem a legenda "B323 - Averiguação da Separação
		 * Consolidada" e `SIST_MAINFORM.pas:2249` abre por ele o
		 * `TfPROC_AVERIGUACAO_CAIXA_UNIDADE`. Existe nas duas bases — 45 usuários
		 * na EPOCA, 26 na AGALDINO.
		 */
		categoria: 'Expedição',
		label: nomesRotinasExpedicao.AVERIGUACAO_SEPARACAO_CONSOLIDADA,
		nome: 'mni_AveriguacaoSeparacaoConsolidada',
		rotina: "averiguacao/consolidada",
		tela: 'PROC_AVERIGUACAO_CAIXA_UNIDADE',
		disponivel: true
	},
	/*
	 * 363 — Monitoramento das Cargas Consolidadas: rotina de desktop/supervisor
	 * (painel de monitoramento). Não entra no menu do coletor. Atalho desktop
	 * fica em `frontend/src/data/menuStation.ts`.
	 */
];

export { rotinasExpedicao };
